import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ComponentBase } from '@drl/core/component-base';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { GetAppoinmentModel } from '@drl/shared/models';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core/lib/translate.service';
import { ToastrService } from 'ngx-toastr';
import { AppoinmentService } from '../appoinment.service';
import { DialogChatComponent } from '../dialog-chat/dialog-chat.component';
import { DialogFeedbackComponent } from '../dialog-feedback/dialog-feedback.component';
import { CONSTANTSSTATUS, CONSTSTATUS, CONSTSFGENTYPE } from './flags.const';
import { UserStatus, userStatusTypesMap } from '@drl/core/enums/user-status.enum';
import { environment } from '@drl/env/environment';
import * as moment from 'moment';
import { format, parseISO } from 'date-fns';
import { PatientAppointmentsService } from '../../patients/patient-appointments.service';

@Component({
  selector: 'app-dialog-edit-appointment',
  templateUrl: './dialog-edit-appointment.component.html',
  styleUrls: ['./dialog-edit-appointment.component.scss'],
})
export class DialogEditAppointmentComponent extends ComponentBase {
  readonly CONSTANTS = CONSTANTSSTATUS;
  readonly CONSTSTATUS = CONSTSTATUS;
  readonly CONSTGENTYPE = CONSTSFGENTYPE;
  readonly brand = environment.brand;
  doctorFeedback: FormGroup;
  user: GetAppoinmentModel;
  userSavedMsg: string;
  successLbl: string;
  errorLbl: string;
  context: [];
  age;
  loading = false;
  users: GetAppoinmentModel[] = [];
  ptsDetailsById;
  ptsDetailById;
  feedback;
  NoFeedback = false;
  careGiverGroupDetails;
  appointmentId;
  rating3: number;
  alternativeContactDetails;
  externalId;
  lastAppoinment;
  patientNote;
  ptsImageUrlEdit;
  lastAppointmentFlag = false;
  showPopupBtn = false;
  hideInsightBtn = true;
  guestAge: number;
  guestGender: string;
  public form: FormGroup;
  updateResponse;
  meetingResponse: any;
  apptDate: string;
  isAnyFeedbackGiven = false;
  durationStatus = false;
  statuses = [];
  tabLbl: string;
  maleTextLbl: string;
  femaleTextLbl: string;
  otherLbl: string;
  AppointmentDate: string;
  AppointmentTime: string;
  filter: any;
  patientFilter: any;
  constructor(
    public dialogRef: NbDialogRef<DialogEditAppointmentComponent>,
    private readonly dialogService: NbDialogService,
    public readonly patientService: AppoinmentService,
    private readonly route: Router,
    private readonly toastrService: ToastrService,
    private readonly formBuilder: FormBuilder,
    protected readonly translateSvc: IpsTranslateService,
    private readonly patientAppointmentService: PatientAppointmentsService,
  ) {
    super();
    this.translate = this.translateSvc.translate;
  }
  translate: TranslateService;

  ngOnInit() {
    this.getTranslations();
    this.appointmentId = this.user.id;
    this.loading = true;
    // this.getAppointmentStatus(this.appointmentId);// Commenting for MVP
    this.doctorFeedbackForm();
    // appointmentDate
    if (this.user.appointmentDate) {
      // this.AppointmentDate = moment(this.user.appointmentDate)
      //   .format(' Do MMM YYYY')
      // .toString();


      const aptDate = parseISO((this.user.appointmentDate).toString());

      this.AppointmentDate = format(aptDate, "do MMMM yyyy");

      this.AppointmentTime = moment(this.user.appointmentDate).format('HH:mm').toString();
    }
    //
    else {
      // this.AppointmentDate = moment(this.user.apptDate)
      //   .format(' Do MMM YYYY')
      // .toString();

      const aptDate = parseISO((this.user.apptDate).toString());

      this.AppointmentDate = format(aptDate, "do MMMM yyyy");

      this.AppointmentTime = moment(this.user.apptDate).format('HH:mm').toString();

    }


    // .subtract(30, "minutes").format('h:mm').toString();
    this.getMeetingUrl(this.user.patientId, this.user.apptDate);
    this.getPatient(this.user.patientId);

    /*  if (this.user.patientImg != null && this.user.patientImg) {
       this.ptsImageUrlEdit = this.user.patientImg;

     } else {
       this.ptsImageUrlEdit = '../../../../assets/patient-avatar.png';
     } */
    this.ptsImageUrlEdit = '../../../../assets/patient-avatar.png';

    this.getPatientNote(this.appointmentId);
    if (this.user.patient) {

      if (this.user.patient.photoUrl != null && this.user.patient.photoUrl) {
        this.ptsImageUrlEdit = this.user.patient.photoUrl;
      }
    }
    else {
      if (this.user.patientImageUrl != null && this.user.patientImageUrl) {
        this.ptsImageUrlEdit = this.user.patientImageUrl;

      }
      else if (this.user.patientImg != null && this.user.patientImg) {
        this.ptsImageUrlEdit = this.user.patientImg;

      }

    }

    // this.getPatientDetails();
    if (this.user.patientType === 'guest_patient') {
      this.guestAgeGender(this.user.id);
    }
    // this.getAlternativeEmailAndMob(this.appointmentId);// Commenting for MVP
    // this.getPatientNote(this.appointmentId);// Commenting for MVP
  }
  /* getAppointmentStatus(appointmentId) {
    const data = {
      appointmentId: appointmentId,
    };
    this.patientService.getAppointmentStatus(data).subscribe(
      res => {
        if (res.status.toString() === CONSTSTATUS.lastAppointmentStatus) {
          this.user.status = res.apptCurrentStatus;
          this.durationStatus =
            typeof res.durationStatus !== 'undefined'
              ? res.durationStatus
              : true;
        }
        this.getReviewRating();
      },
      err => {
        this.getReviewRating();
      },
    );
  } */ /**
   * Description: Function to get age and gender of 'guest_patient'
   * Date:        12-03-2021
   * Author:      Pinaki Majumder
   * @param {guestID}
   * @returns {void}
   */
  guestAgeGender(guestID: number): void {
    const gID = {
      appointmentId: guestID,
    };
    this.patientService.getPatientsDetailsById(gID).subscribe(res => {
      this.guestAge = res.responseResult.age;
      this.guestGender = res.responseResult.gender;
    });
  }

  getPatient(id) {
    this.patientFilter = `?filter={"where":{"id":{"inq":[${id}]}}}`;
    this.patientService
      .getPatientDetailsByPatientId(this.patientFilter)
      .subscribe(res => {
        this.ptsDetailById = res;

        this.ptsDetailsById = this.ptsDetailById[0];
        this.externalId = this.ptsDetailsById.externalId;
        this.age = this.ageFromDateOfBirthday(this.ptsDetailsById.dob);
        if (this.ptsDetailsById.careGroupId) {
          this.getCaregiverGroup(this.ptsDetailsById.careGroupId);
        }

        this.getLastAppoinmentDetails(this.ptsDetailsById.id);
      });
  }

  /*   getPatientDetails() {
      this.patientService.getPatients().subscribe(res => {
        this.ptsDetailsById = res;
        this.ptsDetailsById = this.ptsDetailsById.find(
          x => x.id === this.user.patientId,
        );
        this.externalId = this.ptsDetailsById.externalId;
        this.age = this.ageFromDateOfBirthday(this.ptsDetailsById.dob);
        this.getCaregiverGroup(this.ptsDetailsById.careGroupId);
        this.getLastAppoinmentDetails(this.ptsDetailsById.id);
      });
    } */
  getLastAppoinmentDetails(id) {
    /* const body = {
      patientId: id,
    };
    this.patientService.getLastAppointment(body).subscribe(res => {
      if (res.status.toString() === CONSTSTATUS.lastAppointmentStatus) {
        this.lastAppoinment = res;
        this.lastAppointmentFlag = true;
      } else {
        this.lastAppointmentFlag = false;
      }
    }); */
    const LastAppointmentDetailsLimit = 1;
    this.patientAppointmentService
      .getLastAppointmentDetails(id, LastAppointmentDetailsLimit, {
        patientId: id,
      })
      .subscribe(res => {
        if (res.length.toString() === CONSTSTATUS.lastAppointmentStatus) {
          this.lastAppointmentFlag = true;
          this.lastAppoinment = res[0];
        } else {
          this.lastAppointmentFlag = false;
        }
      });
  }
  getPatientNote(id) {
    const body = {
      appointmentId: id,
    };
    this.patientService.getPatientNote(body, id).subscribe(res => {
      if (res) {
        this.patientNote = res[0];
      }
    });
  }
  getCaregiverGroup(
    body,
  ) {
    this.patientService.getCaregiverGroup(body).subscribe(res => {
      this.careGiverGroupDetails = res;
    });
  }
  doctorFeedbackForm() {
    this.doctorFeedback = this.formBuilder.group({
      doctorRating: [''],
      patientRating: [''],
      rating1: [''],
      rating2: [''],
    });
  }
  public ageFromDateOfBirthday(dateOfBirth): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  editPopUp(user?: GetAppoinmentModel) {
    this.patientService.patientid = user.patientId;
    this.patientService.doctorid = user.doctorId;
    this.patientService.appointmentid = user.id;
    this.patientService.description = user.description;

    this.dialogRef.close();
    this.router.navigateByUrl('main/care-central/appointment');
    this.patientService.doctorDefaultSet = false;
  }
  refresh() {
    this.users = [];
  }

  nursingNotePopUp(user?: GetAppoinmentModel) {
    this.patientService.patientid = user.patientId;
    this.patientService.doctorid = user.doctorId;
    this.patientService.appointmentid = user.id;
    this.patientService.description = user.description;
    this.dialogRef.close();
    const context = {
      user: Object.assign({}, user || new GetAppoinmentModel()),
      isEdit: !!user,
    };

    this._subscriptions.push(
      this.dialogService
        .open(DialogChatComponent, {
          context,
        })
        .onClose.subscribe(res => {
          if (res && res.error) {
            this.toastrService.error(res.message, this.errorLbl, {});
          } else {
            this.refresh();
          }
        }),
    );
  }
  getReviewRating() {
    const body = {
      appointmentId: this.user.id,
    };
    this.patientService.getFeedback(body).subscribe(
      res => {
        this.feedback = res.responseResult;
        this.doctorFeedback
          .get('rating1')
          .setValue(this.feedback.patientRating);
        this.doctorFeedback.get('rating2').setValue(this.feedback.doctorRating);
        if (res.responseResult.doctorRating !== 0) {
          this.NoFeedback = true;
        } else {
          this.NoFeedback = false;
        }
        const resp = res.responseResult;
        if (this.user.status === this.CONSTANTS.statusUnsuccessful) {
          this.isAnyFeedbackGiven = false;
        } else if (
          (resp.doctorAppointmentDone === 'No' ||
            resp.patientAppointmentDone === 'No' ||
            (resp.doctorAppointmentDone === '' &&
              resp.patientAppointmentDone === '' &&
              this.durationStatus === false)) &&
          this.user.status === this.CONSTANTS.statusCompleted
        ) {
          this.isAnyFeedbackGiven = false;
          this.user.status = this.CONSTANTS.statusUnsuccessful;
        } else if (
          resp.doctorAppointmentDone === '' &&
          resp.patientAppointmentDone === '' &&
          this.durationStatus === true &&
          this.user.status === this.CONSTANTS.statusCompleted
        ) {
          this.isAnyFeedbackGiven = true;
        } else if (
          resp.doctorAppointmentDone === '' &&
          resp.patientAppointmentDone === ''
        ) {
          this.isAnyFeedbackGiven = false;
        } else {
          this.isAnyFeedbackGiven = true;
        }
        this.loading = false;
      },
      err => {
        this.loading = false;
      },
    );
  }

  //Prateek
  getMeetingUrl(id, apptDate) {
    const appDate = apptDate ? apptDate : this.user.appointmentDate;
    this.filter = `?filter={"where":{"patientId":${id},"apptDate":{"eq":"${appDate}"}},"include":[{"relation":"appointmentAttendees"},{"relation":"onlineAppointmentDetailsMapping"}]}`;
    this.patientService
      .getDoctorMeetingDetailsByPatientId(this.filter)
      .subscribe(res => {
        this.meetingResponse = res;
      });
  }
  startVcMeeting() {
    window.open(this.meetingResponse[0].appointmentAttendees[1].appointmentUrl);
  }

  /*  startVc(id, this.user.apptDate) {
     // this.apptDate = "2023-04-18T06:00:00.000Z";
     // this.filter = `?filter={"where":{"patientId":${id},"and":[{"apptDate":{"gte":"2023-04-16T18:35:00.000Z"}}, {"apptDate":{"lte":"2023-04-19T18:29:59.999Z"}}]},"include":[{"relation":"appointmentAttendees"},{"relation":"onlineAppointmentDetailsMapping"}]}`;
     this.filter = `?filter={"where":{"patientId":${id},"apptDate":{"eq":"2023-04-18T05:00:00.000Z"}},"include":[{"relation":"appointmentAttendees"},{"relation":"onlineAppointmentDetailsMapping"}]}`
     this.patientService.getDoctorMeetingDetailsByPatientId(this.filter).subscribe(res => {
       this.meetingResponse = res;
     });

   } */

  startMeeting() {
    this.updateAppointmnentStatus(this.appointmentId);
    window.open(this.user.webexUrl);
  }
  updateAppointmnentStatus(val: string) {
    const body = {
      appointmentId: val,
      status: 'Ongoing',
    };
    this.patientService.updateAppointmnent(body).subscribe(res => {
      this.updateResponse = res;
    });
  }
  redirectToCalender() {
    this.dialogRef.close();
    this.router.navigateByUrl('main/care-central');
  }
  redirectToDetailsPage() {
    if (this.externalId) {
      const url = this.route.serializeUrl(
        this.route.createUrlTree([
          `main/patients/${this.externalId}/patient-details`,
        ]),
      );
      window.open(url, '_blank');
    }
  } // Commenting for MVP

  /* getAlternativeEmailAndMob(val: string) {
    const body = {
      appointmentId: val,
    };
    this.patientService.getAlternativeEmailAndMob(body).subscribe(res => {
      this.alternativeContactDetails = res.responseResult;
    });
  } */ /**
   * Description: Function to get selected tab event
   * Date:        08-03-2021
   * Author:      Pinaki Majumder
   * @param {event}
   * @returns {void}
   */
  nbSelectTab(event): void {
    this.showPopupBtn = false;
    if (event.tabTitle === this.tabLbl) {
      this.showPopupBtn = true;
      this.hideInsightBtn = false;
    } else {
      this.hideInsightBtn = true;
    }
  }

  /**
   * Description: Function to open ratings Feedback popup
   * Date:        12-03-2021
   * Author:      Pinaki Majumder
   * @param {returnMeetingId}
   * @returns {void}
   */
  redirectFeedbackPopUp(
    returnMeetingId: string,
    user?: GetAppoinmentModel,
  ): void {
    this.dialogRef.close();
    const context = {
      returnMeetingId,
      user: Object.assign({}, user || new GetAppoinmentModel()),
    };

    this._subscriptions.push(
      this.dialogService
        .open(DialogFeedbackComponent, {
          context,
        })
        .onClose.subscribe(res => {
          if (res && res.error) {
            this.toastrService.error(res.message, this.errorLbl, {});
          } else {
            // Do nothing
          }
        }),
    );
  }
  public getNameExcerpt(userName: string, splitLength: number) {
    return userName.length > splitLength
      ? userName.slice(0, splitLength) + '...'
      : userName;
  }
  getTranslations() {
    this.translate
      .get([
        'userSavedMsgInt',
        'successLbl',
        'errorLbl',
        'phoneNotValidMsg',
        'feedback',
        'maleTextLbl',
        'femaleTextLbl',
        'otherLbl',
      ])
      .subscribe(res => {
        this.statuses = [
          userStatusTypesMap(this.translate)[UserStatus.REGISTERED],
          userStatusTypesMap(this.translate)[UserStatus.ACTIVE],
          userStatusTypesMap(this.translate)[UserStatus.INACTIVE],
        ];
        this.userSavedMsg = res.userSavedMsgInt;
        this.successLbl = res.successLbl;
        this.errorLbl = res.errorLbl;
        this.tabLbl = res.feedback;
        this.maleTextLbl = res.maleTextLbl;
        this.femaleTextLbl = res.femaleTextLbl;
        this.otherLbl = res.otherLbl;
      });
  }
  public getGenderLbl(genderLbl: string) {
    if (
      genderLbl === this.CONSTGENTYPE.Male ||
      genderLbl === this.CONSTGENTYPE.GMale
    ) {
      return this.maleTextLbl;
    } else if (
      genderLbl === this.CONSTGENTYPE.Female ||
      genderLbl === this.CONSTGENTYPE.GFemale
    ) {
      return this.femaleTextLbl;
    } else if (
      genderLbl === this.CONSTGENTYPE.Other ||
      genderLbl === this.CONSTGENTYPE.GOther
    ) {
      return this.otherLbl;
    } else {
      return null;
    }
  }
}